import { useMemo, useState } from "react"
import {
    Box,
    Button,
    DataTable,
    Layer,
    Tab,
    Text,
} from "grommet"
import { FormClose } from "grommet-icons"
import { formatDateHour } from "../utils/helper"
import { useTranslation } from "react-i18next"

const MetadataTab = ({ metadata = [] }) => {
    const [selectedMetadata, setSelectedMetadata] = useState(null)
    const { t } = useTranslation()
    const total = useMemo(() => metadata?.length ?? 0, [metadata])

    return (
        <Tab key="metadata" title={<>{total} Données complémentaires</>}>
            <Box pad={{ vertical: "medium" }} gap="small">
                {(!total) ? (
                    <Text>Aucune donnée complémentaire n&apos;est disponible.</Text>
                ) : (
                    <div className="mobileTableWrapper">
                        <DataTable
                            className="mobileTable"
                            data={metadata}
                            columns={[
                                {
                                    property: "id",
                                    primary: true,
                                    header: "Type de données",
                                    render: item => t(item.feature, { ns: 'metadata' }),
                                },
                                {
                                    property: "created_at",
                                    header: "Créé le",
                                    render: item => formatDateHour(item.created_at),
                                },
                                {
                                    property: "updated_at",
                                    header: "Modifié le",
                                    render: item => formatDateHour(item.updated_at),
                                },
                            ]}
                            onClickRow={({ datum }) => {
                                setSelectedMetadata(datum)
                            }}
                            fill
                        />
                    </div>
                )}
            </Box>

            {selectedMetadata && (
                <Layer
                    modal
                    responsive
                    onEsc={() => setSelectedMetadata(null)}
                    onClickOutside={() => setSelectedMetadata(null)}
                >
                    <Box pad="medium" width="large" gap="medium">
                        <Box direction="row" justify="between" align="center" gap="medium">
                            <Box gap="xsmall">
                                <Text weight="bold" size="large">
                                    {t(selectedMetadata.feature, { ns: 'metadata' })}
                                </Text>
                                <Text size="small" color="dark-5">
                                    Mise à jour: {formatDateHour(selectedMetadata.updated_at) || "-"}
                                </Text>
                            </Box>

                            <Button
                                plain
                                reverse
                                label="Fermer"
                                icon={<FormClose />}
                                onClick={() => setSelectedMetadata(null)}
                            />
                        </Box>

                        <Box background="light-2" pad="medium" round="xsmall" overflow="auto">
                            <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                {JSON.stringify(selectedMetadata.data, null, 2)}
                            </pre>
                        </Box>
                    </Box>
                </Layer>
            )}
        </Tab>
    )
}

export { MetadataTab }